import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Данные успешно сохранены", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Отчет успешно удален", -1)
const _hoisted_3 = { class: "mb-4 d-flex flex-row justify-content-start align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Создать отчет ")
const _hoisted_5 = { class: "border rounded bg-white px-3 py-3 mb-5" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center py-5 my-5"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Дата")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Менеджер")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Уборок")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Химчисток")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Список отчетов пуст ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "После удаление будет выполнен пересчет всех отчетов", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Отменить")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Удалить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CAlert = _resolveComponent("CAlert")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_CTableHeaderCell = _resolveComponent("CTableHeaderCell")!
  const _component_CTableRow = _resolveComponent("CTableRow")!
  const _component_CTableHead = _resolveComponent("CTableHead")!
  const _component_CTableDataCell = _resolveComponent("CTableDataCell")!
  const _component_CTableBody = _resolveComponent("CTableBody")!
  const _component_CTable = _resolveComponent("CTable")!
  const _component_CModalTitle = _resolveComponent("CModalTitle")!
  const _component_CModalHeader = _resolveComponent("CModalHeader")!
  const _component_CTabContent = _resolveComponent("CTabContent")!
  const _component_CModalBody = _resolveComponent("CModalBody")!
  const _component_CModalFooter = _resolveComponent("CModalFooter")!
  const _component_CModal = _resolveComponent("CModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.successSave)
      ? (_openBlock(), _createBlock(_component_CAlert, {
          key: 0,
          color: "success",
          dismissible: "",
          class: "d-flex align-items-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CIcon, {
              icon: "cil-check-circle",
              class: "flex-shrink-0 me-2",
              width: "24",
              height: "24"
            }),
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (this.successDelete)
      ? (_openBlock(), _createBlock(_component_CAlert, {
          key: 1,
          color: "success",
          dismissible: "",
          class: "d-flex align-items-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CIcon, {
              icon: "cil-check-circle",
              class: "flex-shrink-0 me-2",
              width: "24",
              height: "24"
            }),
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        custom: "",
        to: "/reports/add",
        class: "sidebar-header__balance"
      }, {
        default: _withCtx(({ navigate }) => [
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_CButton, {
                key: 0,
                color: "primary",
                onClick: navigate
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CIcon, { icon: "cil-plus" }),
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_CSpinner, { color: "primary" })
          ]))
        : (_openBlock(), _createBlock(_component_CTable, {
            key: 1,
            striped: "",
            hover: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CTableHead, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CTableRow, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableHeaderCell, { scope: "col" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CTableBody, null, {
                default: _withCtx(() => [
                  (_ctx.reports.length === 0)
                    ? (_openBlock(), _createBlock(_component_CTableRow, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CTableHeaderCell, {
                            scope: "row",
                            colspan: "6",
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.reports, (report) => {
                        return (_openBlock(), _createBlock(_component_CTableRow, {
                          key: report,
                          align: "middle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(report.reportDate), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_CTableDataCell, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(report.manager.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_CTableDataCell, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(report.cleaningCount), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_CTableDataCell, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(report.dryCleaningCount), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_CTableDataCell, { class: "text-end" }, {
                              default: _withCtx(() => [
                                (_ctx.isCurrentUserAdmin)
                                  ? (_openBlock(), _createBlock(_component_CButton, {
                                      key: 0,
                                      color: "danger",
                                      class: "me-3",
                                      onClick: ($event: any) => (_ctx.deleteReport = report)
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CIcon, { icon: "cil-trash" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_router_link, {
                                  custom: "",
                                  to: `/reports/edit/${report.id}`
                                }, {
                                  default: _withCtx(({ navigate }) => [
                                    _createVNode(_component_CButton, {
                                      color: "success",
                                      onClick: navigate
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CIcon, { icon: "cil-pencil" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _createVNode(_component_CModal, {
      visible: _ctx.deleteReport !== null,
      onClose: _ctx.onReportDeleteModalClose,
      backdrop: "static"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CModalHeader, null, {
          default: _withCtx(() => [
            _createVNode(_component_CModalTitle, null, {
              default: _withCtx(() => [
                _createTextVNode("Удалить отчет за " + _toDisplayString(_ctx.deleteReport.reportDate) + "?", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CModalBody, { class: "py-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_CTabContent, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CModalFooter, {
          class: _normalizeClass(_ctx.deleteReportLoading ? 'modal-footer--overlaid' : '')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CButton, {
              color: "light",
              onClick: _ctx.onReportDeleteModalClose
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_CButton, {
              color: "danger",
              onClick: _ctx.onDeleteReportButtonClick
            }, {
              default: _withCtx(() => [
                (_ctx.deleteReportLoading)
                  ? (_openBlock(), _createBlock(_component_CSpinner, {
                      key: 0,
                      size: "sm",
                      class: "me-2"
                    }))
                  : _createCommentVNode("", true),
                _hoisted_14
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ], 64))
}